import useCompanies from "./useCompanies";

export default useCompanies;
